module.exports = __webpack_public_path__ + "img/a-banner1-2.2797484c.png";